import { get } from 'lodash';

import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface OrderFeesState {
  voucherOrderFees: any[];
  isLoading: boolean;
  loaded: boolean;
  noPersistance: boolean;
  vatFeePercent: number;
  isError?: boolean;
}

interface OrderFeesPayload {
  voucherFees?: any[];
  vatFeePercent: number;
}

export const getInitialState = (): OrderFeesState => ({
  voucherOrderFees: [],
  isLoading: false,
  loaded: false,
  noPersistance: true,
  vatFeePercent: 0
});

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_ORDER_FEES}_REQUEST`]: (
    state: OrderFeesState
  ): Partial<OrderFeesState> => ({
    isLoading: true
  }),

  [`${ApiConstants.LOAD_ORDER_FEES}_SUCCESS`]: (
    state: OrderFeesState,
    { payload }: { payload: OrderFeesPayload }
  ): Partial<OrderFeesState> => ({
    voucherOrderFees: get(payload, 'voucherFees') || [],
    loaded: true,
    isLoading: false,
    vatFeePercent: payload.vatFeePercent
  }),

  [`${ApiConstants.LOAD_ORDER_FEES}_FAILURE`]: (
    state: OrderFeesState
  ): Partial<OrderFeesState> | OrderFeesState =>
    !state.isError
      ? {
          isLoading: false,
          loaded: true,
          isError: true
        }
      : state
});
